(() => {
  if (window.FiivePredictiveGifts || document.querySelector('fiive-cart-experience')) return;
  window.FiivePredictiveGifts = true;

  const GOAL = 5000;
  const MIN_GIFTS = 5;
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const STORE_KEY = 'fp_predictive_gifts_v3';
  const GIFT_POOL = ROOT + 'collections/fiive-plus-free-gift-pool/products.json?limit=250';
  let giftPoolPromise = null;
  const PRODUCT_LINK = 'a[href*="/products/"]';
  const state = { source: null, gifts: [], cart: null, open: false, loading: false };
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency',
    currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
  }).format((Number(cents) || 0) / 100);

  const style = document.createElement('style');
  style.id = 'fp-predictive-gifts-style';
  style.textContent = `
    :root{--fp-gift-orange:#ff6a00;--fp-gift-green:#118735;--fp-gift-ink:#171717;--fp-gift-muted:#686868;--fp-gift-line:#e7e7e7;--fp-gift-soft:#fff4eb}
    .fp-gift-launcher{position:fixed;z-index:42;left:10px;bottom:calc(76px + env(safe-area-inset-bottom,0px));display:flex;align-items:center;gap:8px;min-height:44px;padding:7px 13px 7px 8px;border:1px solid #ffb681;border-radius:999px;background:#fff;box-shadow:0 6px 22px rgba(0,0,0,.14);color:var(--fp-gift-ink);font:800 12px/1.1 inherit;cursor:pointer}
    .fp-gift-launcher__mark{display:grid;place-items:center;width:30px;height:30px;border-radius:50%;background:var(--fp-gift-orange);color:#fff;font-size:13px;font-weight:950}
    .fp-gift-launcher .fp-gift-launcher__mark{background:#f6f6f6}
    .fp-gift-launcher small{display:block;margin-top:2px;color:var(--fp-gift-muted);font-size:9px;font-weight:700}
    .fp-gift-toast{position:fixed;z-index:43;left:12px;right:12px;bottom:calc(68px + env(safe-area-inset-bottom,0px));display:none;align-items:center;gap:9px;padding:11px 13px;border:1px solid #ffd0ae;border-radius:12px;background:#fff;box-shadow:0 8px 28px rgba(0,0,0,.16);color:var(--fp-gift-ink);font:800 12px/1.3 inherit}
    .fp-gift-toast.is-visible{display:flex;animation:fpGiftIn .24s ease-out}
    .fp-gift-toast strong{color:var(--fp-gift-orange)}
    .fp-gift-shell{position:fixed;z-index:100001;inset:0;display:none}
    .fp-gift-shell.is-open{display:block}
    .fp-gift-backdrop{position:absolute;inset:0;border:0;background:rgba(0,0,0,.47);cursor:pointer}
    .fp-gift-panel{position:absolute;left:0;right:0;bottom:0;max-height:min(88dvh,760px);overflow:auto;padding:14px 12px calc(16px + env(safe-area-inset-bottom,0px));border-radius:18px 18px 0 0;background:#fff;color:var(--fp-gift-ink);box-shadow:0 -12px 42px rgba(0,0,0,.2)}
    .fp-gift-head{display:flex;align-items:flex-start;justify-content:space-between;gap:14px}
    .fp-gift-eyebrow{margin:0 0 3px;color:var(--fp-gift-orange);font-size:10px;font-weight:900;letter-spacing:.08em;text-transform:uppercase}
    .fp-gift-title{margin:0;font-size:22px;line-height:1.08;letter-spacing:-.035em}
    .fp-gift-close{display:grid;place-items:center;flex:0 0 44px;width:44px;height:44px;margin:-7px -6px 0 0;border:0;border-radius:50%;background:#f4f4f4;color:#111;font-size:23px;cursor:pointer}
    .fp-gift-copy{margin:8px 0 12px;color:var(--fp-gift-muted);font-size:12px;line-height:1.45}
    .fp-gift-meter{padding:11px;border:1px solid #ffd1b0;border-radius:12px;background:var(--fp-gift-soft)}
    .fp-gift-meter__row{display:flex;justify-content:space-between;gap:8px;margin-bottom:8px;font-size:11px;font-weight:850}
    .fp-gift-meter__row b{color:var(--fp-gift-orange)}
    .fp-gift-track{height:8px;overflow:hidden;border-radius:999px;background:#eaded5}
    .fp-gift-fill{height:100%;width:0;border-radius:inherit;background:linear-gradient(90deg,#ff6a00,#ff8a2b);transition:width .35s ease}
    .fp-gift-meter.is-unlocked{border-color:#bce2c7;background:#effaf2}
    .fp-gift-meter.is-unlocked .fp-gift-meter__row b{color:var(--fp-gift-green)}
    .fp-gift-meter.is-unlocked .fp-gift-fill{background:var(--fp-gift-green)}
    .fp-gift-subhead{display:flex;justify-content:space-between;align-items:end;gap:12px;margin:17px 0 9px}
    .fp-gift-subhead h3{margin:0;font-size:15px;letter-spacing:-.015em}
    .fp-gift-subhead span{color:var(--fp-gift-muted);font-size:9px;font-weight:750}
    .fp-gift-grid{display:grid;grid-auto-flow:column;grid-auto-columns:42%;gap:9px;overflow-x:auto;padding:1px 1px 8px;scroll-snap-type:x mandatory;scrollbar-width:none}
    .fp-gift-grid::-webkit-scrollbar{display:none}
    .fp-gift-card{position:relative;scroll-snap-align:start;min-width:0;border:1px solid var(--fp-gift-line);border-radius:10px;background:#fff;overflow:hidden}
    .fp-gift-card__image{position:relative;aspect-ratio:1;background:#f6f6f6}
    .fp-gift-card img{width:100%;height:100%;object-fit:contain;display:block}
    .fp-gift-card__badge{position:absolute;left:5px;top:5px;padding:4px 6px;border-radius:999px;background:#171717;color:#fff;font-size:8px;font-weight:900;text-transform:uppercase}
    .is-unlocked .fp-gift-card__badge{background:var(--fp-gift-green)}
    .fp-gift-card__body{padding:7px}
    .fp-gift-card__title{display:-webkit-box;min-height:29px;overflow:hidden;-webkit-box-orient:vertical;-webkit-line-clamp:2;margin:0;color:#222;font-size:10px;font-weight:750;line-height:1.35}
    .fp-gift-card__price{margin-top:4px;color:var(--fp-gift-orange);font-size:11px;font-weight:950}
    .fp-gift-card__price s{margin-left:3px;color:#888;font-size:9px;font-weight:650}
    .fp-gift-claim{display:flex;width:100%;min-height:38px;align-items:center;justify-content:center;margin-top:7px;padding:7px;border:0;border-radius:8px;background:var(--fp-gift-orange);color:#fff;font:850 10px/1 inherit;cursor:pointer}
    .fp-gift-claim:disabled{background:#e7e7e7;color:#777;cursor:default}
    .is-unlocked .fp-gift-claim:not(:disabled){background:var(--fp-gift-green)}
    .fp-gift-note{margin:10px 1px 0;color:#777;font-size:9px;line-height:1.4}
    .fp-gift-loading{display:grid;place-items:center;min-height:155px;color:#777;font-size:11px}
    .fp-gift-empty{padding:18px 12px;border:1px dashed #d7d7d7;border-radius:10px;color:#666;text-align:center;font-size:11px}
    @keyframes fpGiftIn{from{opacity:0;transform:translateY(7px)}to{opacity:1;transform:none}}
    @media(min-width:750px){
      .fp-gift-launcher{left:22px;bottom:22px}
      .fp-gift-toast{left:22px;right:auto;bottom:78px;max-width:390px}
      .fp-gift-panel{left:auto;top:0;bottom:0;width:min(470px,92vw);max-height:none;border-radius:0;padding:22px 20px}
      .fp-gift-grid{grid-auto-columns:30%}
    }
    @media(prefers-reduced-motion:reduce){.fp-gift-fill,.fp-gift-toast{transition:none;animation:none}}
  `;
  document.head.appendChild(style);

  const shell = document.createElement('div');
  shell.className = 'fp-gift-shell';
  shell.setAttribute('aria-hidden', 'true');
  shell.innerHTML = `
    <button class="fp-gift-backdrop" type="button" aria-label="Close free gift preview"></button>
    <section class="fp-gift-panel" role="dialog" aria-modal="true" aria-labelledby="fp-gift-title" tabindex="-1">
      <div class="fp-gift-head">
        <div><p class="fp-gift-eyebrow">The Fiive Plus promise</p><h2 class="fp-gift-title" id="fp-gift-title">5+ free gifts with $50+</h2></div>
        <button class="fp-gift-close" type="button" aria-label="Close">×</button>
      </div>
      <p class="fp-gift-copy">Shop what you love. We predict complementary extras and unlock at least five when your qualifying merchandise reaches $50.</p>
      <p class="fp-gift-copy">Nonmembers pay one $5.95 Service Fee when choosing promotional gifts. You can decline gifts and shop without it. Verified active fiive+ extra members are exempt. <a href="${ROOT}pages/fiive-service-fee-policy">Service Fee Policy</a>.</p>
      <div class="fp-gift-meter"><div class="fp-gift-meter__row"><span data-fp-gift-status>Checking your cart…</span><b data-fp-gift-total>$0.00 / $50.00</b></div><div class="fp-gift-track"><div class="fp-gift-fill"></div></div></div>
      <div class="fp-gift-subhead"><h3 data-fp-gift-heading>Your predicted gifts</h3><span>Personalized as you browse</span></div>
      <div class="fp-gift-results"><div class="fp-gift-loading">Finding complementary gifts…</div></div>
      <p class="fp-gift-note">Gift assortment may change with product availability. Final eligible selection and $0 pricing must be confirmed in your cart before checkout.</p>
    </section>`;
  document.body.appendChild(shell);

  const launcher = document.createElement('button');
  launcher.type = 'button';
  launcher.className = 'fp-gift-launcher';
  launcher.setAttribute('aria-label', 'Preview your five or more free gifts');
  launcher.innerHTML = '<span class="fp-gift-launcher__mark">🎁</span><span>5 FREE gifts<small data-fp-launcher-copy>Unlock at $50</small></span>';
  document.body.appendChild(launcher);

  const toast = document.createElement('button');
  toast.type = 'button';
  toast.className = 'fp-gift-toast';
  toast.innerHTML = '<span class="fp-gift-launcher__mark">5+</span><span><strong>Gift preview updated.</strong><br>See what pairs with this item.</span>';
  document.body.appendChild(toast);

  const $ = selector => shell.querySelector(selector);
  const isGiftLine = item => item && item.properties && String(item.properties._fp_free_gift || '') === 'true';
  const subtotal = () => state.cart && Array.isArray(state.cart.items)
    ? state.cart.items.filter(item => !isGiftLine(item) && !item.gift_card && !item.selling_plan_allocation && !['67580027076915','67580026880307','67580247933235','54143422726451'].includes(String(item.variant_id)) && !item.properties?._fp_service).reduce((sum,item) => sum + Number(item.final_line_price ?? item.line_price ?? 0), 0)
    : 0;
  const isClaimedGiftLine = item => isGiftLine(item) && !item.selling_plan_allocation && item.properties._fp_program !== 'extra_monthly' && item.final_line_price === 0;
  const claimed = () => state.cart && Array.isArray(state.cart.items)
    ? state.cart.items.filter(isClaimedGiftLine).reduce((sum,item) => sum + Number(item.quantity || 0), 0)
    : 0;
  const claimedVariants = () => new Set((state.cart && state.cart.items || []).filter(isClaimedGiftLine).map(item => String(item.variant_id)));
  const giftVariants = () => new Set((state.cart && state.cart.items || []).filter(isGiftLine).map(item => String(item.variant_id)));
  const supportedCurrency = () => state.cart?.currency === 'USD';
  const giftsWanted = () => state.cart?.attributes?.fp_promotional_gifts !== 'declined';
  const unlocked = () => supportedCurrency() && giftsWanted() && subtotal() >= GOAL;
  const save = () => {
    try { sessionStorage.setItem(STORE_KEY, JSON.stringify({source: state.source, gifts: state.gifts, at: Date.now()})); } catch (_) {}
  };
  const restore = () => {
    try {
      const data = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null');
      if (data && Date.now() - data.at < 86400000) {
        state.source = data.source || null;
        state.gifts = Array.isArray(data.gifts) ? data.gifts : [];
      }
    } catch (_) {}
  };
  const shuffle = list => {
    const copy = list.slice();
    for (let i = copy.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [copy[i], copy[j]] = [copy[j], copy[i]];
    }
    return copy;
  };
  const handleFrom = link => {
    try {
      const match = new URL(link.href, location.origin).pathname.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (_) { return ''; }
  };
  const currentHandle = () => {
    const match = location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  };
  const fetchJson = url => fetch(url, {headers:{Accept:'application/json'}}).then(r => {
    if (!r.ok) throw new Error('Request failed');
    return r.json();
  });
  async function getCart() {
    try { state.cart = await fetchJson(ROOT + 'cart.js'); } catch (_) { state.cart = {items_subtotal_price:0}; }
    renderMeter();
  }
  function renderMeter() {
    const amount = subtotal();
    const left = Math.max(0, GOAL - amount);
    const qualified = unlocked();
    const meter = $('.fp-gift-meter');
    meter.classList.toggle('is-unlocked', qualified);
    $('[data-fp-gift-status]').textContent = !supportedCurrency() ? 'Free gift eligibility is currently available for USD orders.' : !giftsWanted() ? 'Promotional gifts declined. Review your cart to include them again.' : qualified ? (claimed() + ' of 5 free gifts claimed') : money(left) + ' away from 5+ free gifts';
    $('[data-fp-gift-total]').textContent = money(amount) + ' / ' + money(GOAL);
    $('.fp-gift-fill').style.width = Math.min(100, amount / GOAL * 100) + '%';
    launcher.querySelector('[data-fp-launcher-copy]').textContent = !supportedCurrency() ? 'USD orders only' : !giftsWanted() ? 'Gifts declined' : qualified ? 'Unlocked in cart' : money(left) + ' to unlock';
    shell.classList.toggle('is-unlocked', qualified);
    $('[data-fp-gift-heading]').textContent = qualified ? 'Your unlocked gift preview' : 'Your predicted gifts';
    renderGifts();
  }
  function imageOf(p) {
    if (p.featured_image) return typeof p.featured_image === 'string' ? p.featured_image : p.featured_image.url;
    if (p.images && p.images[0]) return typeof p.images[0] === 'string' ? p.images[0] : p.images[0].src;
    return '';
  }
  function renderGifts() {
    const root = $('.fp-gift-results');
    if (state.loading) { root.innerHTML = '<div class="fp-gift-loading">Finding complementary gifts…</div>'; return; }
    if (!state.gifts.length) { root.innerHTML = '<div class="fp-gift-empty">Explore products to see available gift suggestions. Gift eligibility is confirmed in your cart.</div>'; return; }
    const label = unlocked() ? 'Unlocked' : 'Gift preview';
    root.innerHTML = '<div class="fp-gift-grid">' + state.gifts.slice(0, 6).map(p => {
      const giftVariant = (p.variants || []).find(variant => variant.available !== false) || {};
      const price = Math.round(Math.max(Number(giftVariant.compare_at_price || 0), Number(giftVariant.price || 0)) * 100);
      const img = imageOf(p);
      return '<article class="fp-gift-card"><div class="fp-gift-card__image">' +
        (img ? '<img src="' + img.replace(/"/g,'&quot;') + '" alt="" loading="lazy" width="220" height="220">' : '') +
        '<span class="fp-gift-card__badge">' + label + '</span></div><div class="fp-gift-card__body"><p class="fp-gift-card__title">' +
        String(p.title || 'A complementary surprise').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])) +
        '</p><div class="fp-gift-card__price">' + money(0) + (price ? ' <s>' + money(price) + '</s>' : '') + '</div>' + (window.FiiveMerchandising?.localBadge({...p,available:(p.variants || []).some(variant => variant.available !== false)}) || '') +
        (() => {
          const variant = Array.isArray(p.variants) ? p.variants.find(v => v.available !== false) : null;
          const already = variant && unlocked() && claimedVariants().has(String(variant.id));
          const pending = variant && !already && giftVariants().has(String(variant.id));
          const full = claimed() >= MIN_GIFTS;
          const disabled = !unlocked() || !variant || already || pending || full;
          const copy = !supportedCurrency() ? 'USD orders only' : !giftsWanted() ? 'Gifts declined' : already ? 'Claimed' : pending ? 'Review in cart' : full ? '5 gifts selected' : unlocked() ? 'Claim free gift' : 'Unlock at $50';
          return '<button class="fp-gift-claim" type="button" data-fp-gift-claim="' + (variant ? variant.id : '') + '"' + (disabled ? ' disabled' : '') + '>' + copy + '</button>';
        })() + '</div></article>';
    }).join('') + '</div>';
  }
  const pool = () => {
    if (!giftPoolPromise) {
      giftPoolPromise = (async () => {
        const products = new Map();
        for (let page = 1; page <= 101; page++) {
          const data = await fetchJson(GIFT_POOL + '&page=' + page);
          if (!Array.isArray(data.products)) throw new Error('Gift pool unavailable');
          const before = products.size;
          for (const product of data.products) {
            if (!product || !product.id) throw new Error('Invalid gift product');
            products.set(String(product.id), product);
          }
          if (data.products.length < 250) {
            return [...products.values()].filter(product =>
              product.available !== false &&
              Array.isArray(product.variants) &&
              product.variants.some(variant => variant.available !== false)
            );
          }
          if (products.size === before) throw new Error('Gift pagination did not advance');
        }
        throw new Error('Gift pool pagination limit reached');
      })().catch(error => {
        giftPoolPromise = null;
        throw error;
      });
    }
    return giftPoolPromise;
  };
  const terms = product => {
    const raw = [product.title, product.product_type, product.vendor]
      .concat(Array.isArray(product.tags) ? product.tags : [])
      .join(' ')
      .toLowerCase();
    return new Set(raw.split(/[^a-z0-9]+/).filter(word => word.length > 2));
  };
  const score = (sourceProduct, gift) => {
    const a = terms(sourceProduct);
    const b = terms(gift);
    let value = 0;
    b.forEach(word => { if (a.has(word)) value += word.startsWith('fp') ? 5 : 1; });
    if (sourceProduct.product_type && sourceProduct.product_type === gift.product_type) value += 4;
    return value + Math.random() * 1.5;
  };
  function selectPredictedGifts(sourceProduct, eligible) {
    const tags = Array.isArray(sourceProduct.tags) ? sourceProduct.tags : String(sourceProduct.tags || '').split(',').map(tag => tag.trim());
    const handles = [...new Set(tags.filter(tag => tag.startsWith('fp:gift:')).map(tag => tag.slice(8)).filter(Boolean))].slice(0, 2);
    const candidates = eligible.filter(gift => String(gift.id) !== String(sourceProduct.id));
    const paired = handles.map(handle => candidates.find(gift => gift.handle === handle)).filter(Boolean);
    const pairedIds = new Set(paired.map(gift => String(gift.id)));
    const ranked = candidates.filter(gift => !pairedIds.has(String(gift.id)))
      .map(gift => ({gift, rank: score(sourceProduct, gift)}))
      .sort((a, b) => b.rank - a.rank);
    return paired.concat(shuffle(ranked.slice(0, 8)).map(entry => entry.gift)).slice(0, 6);
  }
  async function predictions(handle, announce) {
    if (!handle || state.loading) return;
    state.loading = true;
    renderGifts();
    try {
      const [product, eligible] = await Promise.all([
        fetchJson(ROOT + 'products/' + encodeURIComponent(handle) + '.js'),
        pool()
      ]);
      state.source = {id: product.id, handle, title: product.title};
      state.gifts = selectPredictedGifts(product, eligible);
      save();
      if (announce && state.gifts.length) {
        toast.classList.add('is-visible');
        clearTimeout(toast._timer);
        toast._timer = setTimeout(() => toast.classList.remove('is-visible'), 4200);
      }
    } catch (_) {
      state.gifts = [];
      save();
    } finally {
      state.loading = false;
      renderGifts();
    }
  }
  function open() {
    state.open = true;
    shell.classList.add('is-open');
    shell.setAttribute('aria-hidden','false');
    document.body.style.overflow = 'hidden';
    getCart();
    if (!state.gifts.length) predictions(currentHandle(), false);
    setTimeout(() => $('.fp-gift-panel').focus(), 30);
  }
  function close() {
    state.open = false;
    shell.classList.remove('is-open');
    shell.setAttribute('aria-hidden','true');
    document.body.style.overflow = '';
  }

  shell.addEventListener('click', async event => {
    const button = event.target.closest('[data-fp-gift-claim]');
    if (!button || button.disabled || !unlocked() || claimed() >= MIN_GIFTS) return;
    const id = Number(button.dataset.fpGiftClaim);
    if (!id || giftVariants().has(String(id))) return;
    button.disabled = true;
    button.textContent = 'Adding…';
    try {
      const preference = await fetch(ROOT + 'cart/update.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({attributes:{fp_promotional_gifts:'included'}})});
      if (!preference.ok) throw new Error('Unable to update gift preference');
      const response = await fetch(ROOT + 'cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({items:[{id,quantity:1,properties:{_fp_free_gift:'true','Fiive Plus Gift':'FREE with $50+'}}]})
      });
      if (!response.ok) throw new Error('Unable to add gift');
      await getCart();
      window.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (_) {
      button.disabled = false;
      button.textContent = 'Try again';
    }
  });
  launcher.addEventListener('click', open);
  toast.addEventListener('click', () => { toast.classList.remove('is-visible'); open(); });
  shell.addEventListener('click', e => { if (e.target.closest('.fp-gift-close,.fp-gift-backdrop')) close(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && state.open) close(); });
  document.addEventListener('pointerover', e => {
    const link = e.target.closest && e.target.closest(PRODUCT_LINK);
    if (!link || link.dataset.fpGiftSeen) return;
    link.dataset.fpGiftSeen = 'true';
    predictions(handleFrom(link), false);
  }, {passive:true});
  document.addEventListener('click', e => {
    const link = e.target.closest && e.target.closest(PRODUCT_LINK);
    if (link) predictions(handleFrom(link), true);
  }, true);
  ['cart:updated','cart:refresh','cart:open'].forEach(name => window.addEventListener(name, getCart));
  document.addEventListener('change', e => { if (e.target.closest && e.target.closest('[data-cart-quantity-input],quantity-input')) setTimeout(getCart, 450); });

  restore();
  getCart();
  const handle = currentHandle();
  if (handle) {
    predictions(handle, false);
    setTimeout(() => {
      toast.innerHTML = '<span class="fp-gift-launcher__mark">5+</span><span><strong>Your purchase comes with more.</strong><br>Preview complementary free gifts.</span>';
      toast.classList.add('is-visible');
      toast._timer = setTimeout(() => toast.classList.remove('is-visible'), 5200);
    }, 1100);
  }
})();




